export enum UserTypeCodes {
  NEW_USER = 1,
  EXISTING_USER = 0,
}

export const userTypes: Record<number, string> = {
  1: 'New User',
  0: 'Existing User',
};

export const userLabels = ['New User', 'Existing User'];

export const userCodes: Record<string, number> = {
  'New User': 1,
  'Existing User': 0,
};
